import { Box, SxProps, Typography, useTheme } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { FC } from 'react';

import { pxToRem } from '@/theme/typography';
import ImageBoxFuture from '@/components/shared/image-box-future';

const EmptyTransactionsIcon = '/icons/profile/Empty-transactions.svg';

interface MyTransactionsEmptyStateProps {
  accordionSx: SxProps;
  message: string;
}
export const MyTransactionsEmptyState: FC<MyTransactionsEmptyStateProps> = ({
  accordionSx,
  message,
}) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <Box
      sx={{
        ...accordionSx,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: 'none',
        mt: 0,
      }}
    >
      <ImageBoxFuture
        img={EmptyTransactionsIcon}
        title={intl.formatMessage({
          id: 'alt.my_wallet',
        })}
        objectFit='contain'
        sx={{
          width: { tablet: pxToRem(180), mobile: '180px' },
          height: { tablet: pxToRem(140), mobile: '140px' },
          marginBottom: '32px',
        }}
      />
      <Typography
        sx={{
          fontSize: {
            mobile: '16px',
            tablet: pxToRem(20),
          },
          letterSpacing: {
            tablet: pxToRem(0.1),
          },
          color: theme.palette.grey[50],
          textAlign: 'center',
          maxWidth: '461px',
        }}
      >
        <FormattedMessage id={message} />
      </Typography>
    </Box>
  );
};

export default MyTransactionsEmptyState;
